{
  "activities": {
    "accessoryProvider": "Aksesuar Sağlayıcı",
    "accessoryRawMaterialProvider": "Hammadde Sağlayıcı",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Yetiştirme",
        "materialProduction": "Hammadde",
        "preProcessor": "Ön İşlemci"
      },
      "fabric": {
        "appret": "Appret",
        "coating": "Kaplama",
        "dyeing": "Boyama/Baskı",
        "lamination": "Laminasyon",
        "materialProduction": "Hammadde",
        "spinning": "İplik üretimi",
        "weavingKnitting": "Dokuma/Örme"
      },
      "leather": {
        "appret": "Apre",
        "dyeing": "Boyama",
        "farm": "Yetiştirme",
        "materialProduction": "Kıyıhane",
        "tanning": "Tabaklama"
      },
      "manufacturing": "Üretici",
      "yarn": {
        "dyeing": "Boyama",
        "materialProduction": "Hammadde",
        "spinning": "İplik üretimi"
      }
    },
    "brand": "marka",
    "certifiedEntity": "sertifikalıVarlık",
    "footwear": {
      "assembling": "Montaj",
      "finishing": "Finisaj",
      "stitching": "Dikiş"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Montaj",
      "bleaching": "Ağartma",
      "chemicalTreatment": "Kimyasal işlem",
      "laminating": "Laminasyon",
      "manufacturing": "Üretim",
      "pressing": "Presleme",
      "printing": "Baskı",
      "resineRemoving": "Reçine giderme",
      "whiteWashing": "Beyaz yıkama"
    },
    "product": {
      "productWashing": "Ürün bulaşması",
      "washing": "Bulaşma"
    },
    "wood": {
      "assembling": "Montaj",
      "brushing": "Fırçalama",
      "calibrationAndCollage": "Kalibrasyon ve kolaj",
      "harvesting": "Hasat",
      "manufacturing": "Üretim",
      "materialDrying": "Kurutma",
      "materialPeeking": "Ayıklama",
      "materialPeeling": "Soyma",
      "materialSawing": "Kesim",
      "sanding": "Zımpara"
    }
  },
  "batchModal": {
    "actions": {
      "selectEmpty": "Yalnızca boşları seç"
    },
    "applyButton": "{{ itemCount }} öğeye {{type}} uygula",
    "batchUpdateSuccess": "Güncelleme başarılı",
    "batchUpdateSuccessMessage_one": "1 bilgi talebi güncellendi",
    "batchUpdateSuccessMessage_many": "{{count}} bilgi talebi güncellendi",
    "batchUpdateSuccessMessage_other": "{{count}} bilgi talebi güncellendi",
    "info": "<b>{{count}}</b> diğer öğe bu etkinliğe sahip: <b><activity/><b>",
    "labels": {
      "certificate": "Sertifika",
      "clientName": "Müşteri Adı",
      "componentName": "Malzeme adı",
      "componentReference": "Bileşen Referansı",
      "contact": "İletişim",
      "documentProof": "Sertifika",
      "informationRequestItemReference": "Talep Referansı",
      "informationRequestItemReferenceHint": "Bu, bilgi talebinin ilişkili olduğu öğenin referansına atıfta bulunur (örneğin, ürün, malzeme veya bileşen referansı)",
      "materialName": "Malzeme adı",
      "materialProportion": "Malzeme Oranı",
      "materialReference": "Malzeme Referansı",
      "productCollection": "Ürün Koleksiyonu",
      "productColor": "Ürün Rengi",
      "productId": "Ürün ID'si",
      "productionSite": "Üretim Yeri",
      "productName": "Ürün Adı",
      "productReference": "Ürün Referansı",
      "purchaseOrder": "Satın alma siparişi",
      "purchaseOrderRef": "Sipariş Referansı",
      "reference": "Referans"
    },
    "noDocument": "Sertifika Yok",
    "searchProduct": "Ürün ara",
    "title": "Bu işlemi birden fazla öğeye uygulamak istiyor musunuz?"
  },
  "batchPopover": {
    "button": "Toplu Güncelle...",
    "certificateText": "Bu sertifikayı birden fazla talebe uygulamak istiyor musunuz?",
    "text": "Bu {{key}}'yi birkaç <b> <activity /> </b>'ye uygulamak istiyor musunuz?"
  },
  "certificateBatchModal": {
    "labels": {
      "certificate": "Sertifika",
      "products": "Ürünler",
      "type": "Tip"
    },
    "success_one": "{{count}} sertifika talebi başarıyla güncellendi",
    "success_other": "{{count}} sertifika talebi başarıyla güncellendi"
  },
  "certificateRequestStatus": {
    "ACCEPTED": "Kabul Edildi",
    "OPENED": "Açık",
    "REJECTED": "Reddedildi",
    "SUBMITTED": "Bekliyor"
  },
  "certificates": {
    "actions": {
      "delete": "Sil",
      "submit": "Gönder",
      "transfer": "transfer etmek"
    },
    "activityName": "İzlenebilirlik Adı:",
    "labels": {
      "maxIssueDate": "Maksimum sertifika tarihi",
      "purchaseOrder": "Satın alma siparişi veya fatura numarası"
    },
    "modal": {
      "areyousure": "Bu sertifikayı silmek istediğinizden emin misiniz (bu işlem geri alınamaz)?",
      "no": "Hayır",
      "yes": "Evet, Sil"
    },
    "noRequests": {
      "closed": "Tamamlanan sertifika talebi yok",
      "open": "Bekleyen sertifika talebi yok"
    },
    "productionSite": "Üretim Sitesi",
    "productionSitePending": "Üretim sitesi bilgileri bekliyor",
    "purchaseOrder": {
      "actions": {
        "seeLess": "Ürünleri Gizle",
        "seeMore": "Ürünleri Göster"
      },
      "productReferences": "Ürün Referansları"
    },
    "reference": "Referans: {{reference}}",
    "select": {
      "placeholder": "Yüklemelerinizden bir belge seçin."
    },
    "upload": {
      "title": "Sertifika Yükle"
    }
  },
  "contactModal": {
    "labels": {
      "companyCity": "Şirketin şehri",
      "companyCityPlaceholder": "Paris",
      "companyCityTooltip": "Şirketin şehri",
      "companyCountry": "Şirketin ülkesi",
      "companyCountryTooltip": "Şirketin ülkesi",
      "companyIsActive": "Active",
      "companyIsActivePlaceholder": "Active",
      "companyIsActiveTooltip": "Identify business partners currently active and available for trade.",
      "companyName": "Şirket Adı",
      "companyNamePlaceholder": "Şirket Adı",
      "companyNameTooltip": "Şirketin adı",
      "companyPostalCode": "Şirketin posta kodu",
      "companyPostalCodePlaceholder": "75001",
      "companyPostalCodeTooltip": "Şirketin posta kodu",
      "companyRegistrationId": "Şirketin kayıt numarası",
      "companyRegistrationIdDescription": {
        "DUNS": "Unique 9-digit identifier issued by Dun & Bradstreet, commonly used in the US and for international trade. Format: 9-digit numeric code.",
        "EORI": "Identification number for businesses involved in EU customs activities. Format: country code (e.g., FR) + 14-digit SIRET number.",
        "GLN": "Global Location Number - unique identifier for company locations or legal entities under GS1 standard. Format: 13-digit numeric code.",
        "OTHER": "Unique identifier of the company",
        "RCS": "RCS (numéro du registre du commerce): RCS + city + SIREN.",
        "VAT": "European tax identification number for companies liable to VAT. Format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
      },
      "companyRegistrationIdPlaceholder": "1234567890",
      "companyRegistrationIdTooltip": "Şirketin kayıt numarası",
      "companyRelationshipType": {
        "AGENT": "Ajan",
        "BRAND": "Marka",
        "MANUFACTURER": "Üretici",
        "OTHER": "Diğer",
        "RAW_MATERIAL_SUPPLIER": "Ham madde sağlayıcısı",
        "SUPPLIER": "Sağlayıcı",
        "TRADER": "Ticari"
      },
      "companyRelationshipTypeName": "Tip",
      "companyRelationshipTypeTooltip": "Partner şirketinin doğası, tedarik zincirinde rolünü belirlemek için kullanılır.",
      "companyStreet": "Şirketin sokağı",
      "companyStreetPlaceholder": "1 rue de Rivoli",
      "companyStreetTooltip": "Şirketin sokağı",
      "companySupplierCode": "Sipariş Kodu",
      "companySupplierCodePlaceholder": "1234567890",
      "companySupplierCodeTooltip": "Short internal identification code for the business partner.",
      "contactInformation": "contactInformation",
      "coordinates": "coordinates",
      "coordinatesPlaceholder": "coordinatesPlaceholder",
      "email": "E-posta Adresi",
      "emailPlaceholder": "johndoe@gmail.com",
      "emailTooltip": "Şirketin e-posta adresi",
      "name": "Ad",
      "namePlaceholder": "John Doe",
      "nameTooltip": "Şirketin adı",
      "preferredLanguage": "Tercih Edilen Dil",
      "tags": "Etiketler",
      "tagsPlaceholder": "Etiket ekle...",
      "tagsTooltip": "İçsel sınıflandırma, değerlendirme veya herhangi bir bağlamlı bilgi."
    },
    "messages": {
      "create": {
        "error": "error",
        "success": "success"
      },
      "update": {
        "success": "success"
      }
    }
  },
  "contactSelect": {
    "labels": {
      "addNewContact": "Yeni kişi ekle",
      "contact": "Kişi",
      "you": "sen"
    },
    "placeholders": {
      "contact": "Kişi ara"
    }
  },
  "contactTable": {
    "columns": {
      "activity": {
        "name": "Aktivite",
        "tooltip": "Son giriş kaydı."
      },
      "averageResponseTime": {
        "averageResponseTimeValue_one": "{{nbDays}} gün",
        "averageResponseTimeValue_other": "{{nbDays}} gün",
        "name": "Ortalama yanıt süresi",
        "tooltip": "Ortalama yanıt süresi."
      },
      "certificateRequests": {
        "name": "Sertifika talepleri"
      },
      "code": {
        "name": "Kod",
        "tooltip": "İş ortağı için kısa iç kimlik kodu."
      },
      "company": {
        "name": "Şirket",
        "tooltip": "İş ortağı şirketin resmi kamu adı."
      },
      "contactEmail": {
        "name": "İletişim (e-posta)",
        "tooltip": "Ortak şirket içindeki birincil kişinin e-postası."
      },
      "contactName": {
        "name": "İletişim (ad)",
        "tooltip": "Ortak şirket içindeki birincil kişinin adı."
      },
      "location": {
        "name": "Konum",
        "tooltip": "İş ortağı şirketin ülkesi"
      },
      "productionSiteRequests": {
        "name": "Üretim sitesi talepleri",
        "received": "alınan"
      },
      "productionSites": {
        "name": "Üretim siteleri",
        "tooltip": "İş ortağı tarafından beyan edilen sitelerin sayısı ve farklı ülkelerin sayısı."
      },
      "productRequests": {
        "name": "Ürün talepleri"
      },
      "reminder": {
        "name": "Hatırlatma",
        "tooltip": "Son hatırlatma gönderildi."
      },
      "requests": {
        "name": "Talepler",
        "tooltip": "Ortak tarafından yanıtlanan talepler."
      },
      "status": {
        "name": "Durum",
        "tooltip": "Şu anda aktif ve ticaret için mevcut olan iş ortaklarını tanımlar."
      },
      "tags": {
        "name": "Etiketler",
        "tooltip": "İç sınıflandırma, değerlendirme veya diğer bağlamsal bilgiler."
      },
      "type": {
        "name": "Tür",
        "tooltip": "Tedarik zincirindeki rolünü belirlemek için kullanılan ortak şirketin doğası."
      }
    },
    "status": {
      "active": "Aktif",
      "inactive": "Pasif"
    }
  },
  "customFields": {
    "attachment": "Ek",
    "updateCustomField": {
      "customField": {
        "message": "Özel alan değeri güncellendi ve müşteriye gönderildi",
        "title": "Özel alan değeri güncellendi"
      },
      "customFieldProof": {
        "message": "Özel alan sertifikası yüklendi",
        "title": "Özel alan sertifikası yüklendi"
      }
    },
    "uploadCustomFieldProofTooltip": "Özel alan değeri için bir sertifika isteyin"
  },
  "deselectAll": "Tümünü Kaldır",
  "errors": {
    "axiosMessage": "Şu hata oluştu: {{message}} \n\n Lütfen tekrar deneyin veya hata devam ederse support@traceforgood.com ile iletişime geçin",
    "reinforcedTraceability": "Bu isteği kendinize atayamazsınız, lütfen ilgili kişiye transfer edin",
    "title": "Bir hata oluştu"
  },
  "filters": {
    "client": "Müşteri",
    "search": "Ara",
    "status": {
      "canceled": "İptal Edildi",
      "closed": "Kapalı",
      "opened": "Açık",
      "placeholder": "Durum"
    },
    "title": "Filtreler",
    "type": "Tip"
  },
  "item": {
    "brand": "Marka",
    "client": "Müşteri",
    "collection": "Koleksiyon",
    "color": "Renk",
    "component": "Bileşen",
    "date": "Satın Alma Siparişi Tarihi",
    "marketLaunchDate": "Lansman Tarihi",
    "material_one": "Malzeme",
    "material_other": "Malzemeler",
    "name": "Ad",
    "partOf": "Bölümü",
    "product": "Ürün",
    "purchaseOrderRef": "Satın Alma Siparişi",
    "reference": "Referans",
    "type": "Tip"
  },
  "itemType": {
    "component": "Bileşen",
    "material": "Malzeme",
    "product": "Ürün"
  },
  "launch": {
    "modal": {
      "cancel": {
        "button": "button",
        "no": "no",
        "title": "title",
        "yes": "yes"
      },
      "close": {
        "button": "button"
      },
      "eligibleProducts": {
        "checkbox": "checkbox",
        "error": {
          "title": "title"
        },
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        },
        "launchButton": {
          "label": {
            "multiple": "multiple",
            "none": "none",
            "single": "single"
          }
        }
      },
      "fullTraceability": {
        "infoBox": {
          "description": "description",
          "title": "title"
        }
      },
      "header": {
        "description": {
          "default": "default",
          "noTraceabilityCampaign": "noTraceabilityCampaign",
          "runningJob": "runningJob"
        },
        "title": "title"
      },
      "pendingProducts": {
        "infoBox": {
          "description": {
            "multiple": "multiple",
            "single": "single"
          },
          "title": {
            "multiple": "multiple",
            "single": "single"
          }
        }
      },
      "success": {
        "button": "button",
        "description": "description",
        "title": "title"
      }
    }
  },
  "maxError": "{{max}} değerine eşit veya daha küçük olmalıdır",
  "minError": "{{min}} değerine eşit veya daha büyük olmalıdır",
  "operation": {
    "component": "Bileşen",
    "duplicateProductionSite": "Başvuru mümkün olmaya devam etse de, bu sitede diğer adımların belirtildiğini unutmayın.",
    "material": "Malzeme",
    "notOwner": "{{email}} tarafından zaten sağlanan bilgiler.",
    "product": "Ürün",
    "purchaseOrderRef": "Satın Alma Siparişi Referansı",
    "reference": "Tedarikçiniz için {{type}} referansı",
    "unknown": "başka bir kişi"
  },
  "operationNotCreated": "Bir hata oluştu",
  "operationNotCreatedMessage": "Bu isteğin bilgi talebi henüz oluşturulmadı, lütfen support@traceforgood.com ile iletişime geçin",
  "prodsiterequest": {
    "actions": {
      "transfer": "Başka bir kişiye transfer et",
      "transferAll": "Hepsini Transfer Et"
    },
    "noRequests": {
      "closed": "Tamamlanan isteğiniz yok.",
      "open": "Bekleyen isteğiniz yok."
    },
    "status": {
      "INVALID": "Eksik",
      "TOBESUBMITTED": "Gönderilmeye Hazır"
    },
    "transferModal": {
      "success_one": "{{count}} üretim sitesi transfer talebi başarıyla aktarıldı",
      "success_many": "{{count}} üretim sitesi transfer talepleri başarıyla aktarıldı",
      "success_other": "{{count}} üretim sitesi transfer talepleri başarıyla aktarıldı",
      "title": "Üretim sitesi transfer talebi",
      "transferButton": "Transfer Et"
    }
  },
  "productionSiteSelect": {
    "labels": {
      "addNewProductionSite": "Yeni Üretim Sitesi Ekle",
      "productionSite": "Üretim Sitesi"
    },
    "placeholders": {
      "productionSite": "Üretim sitesi ara"
    }
  },
  "reopenRequest": {
    "error": "İstek yeniden açılamadı",
    "feedback_one": "{{count}} alt istek iptal edildi",
    "feedback_other": "{{count}} alt istek iptal edildi",
    "title": "Bu isteği yeniden açmak istediğinizden emin misiniz? (bu eylem bu isteğin tüm alt isteklerini iptal edecektir)",
    "yes": "Evet, Eminim!"
  },
  "request": {
    "complete": "Gönder",
    "completeTooltip": " Talebi tamamlamak ve kapatmak için buraya tıklayın. Aktarılan alt talepler, atanan kişiye yönlendirilecektir.",
    "errors": {
      "generic": "Bir hata oluştu. Lütfen daha sonra tekrar deneyin."
    },
    "incomplete": "Eksik",
    "labels": {
      "composition": "Bileşim",
      "requestDate": "Talep Tarihi"
    },
    "readyToSubmit": "Gönderilecek",
    "seeLess": "Talepi Gizle",
    "seeMore": "Talepi Göster"
  },
  "requests": {
    "noRequests": {
      "closed": "Henüz kapatılmış bir isteğiniz yok.",
      "open": "Bekleyen eyleminizi bekleyen bir isteğiniz yok."
    },
    "tabs": {
      "canceled": "canceled",
      "certificates": {
        "scope": "Kapsam Sertifikaları",
        "transaction": "İşlem Sertifikaları"
      },
      "closed": "Tamamlanan",
      "prodsitefield": "Üretim Site İsteği",
      "traceability": "İzlenebilirlik İstekleri"
    }
  },
  "requiredError": "Zorunlu alan",
  "selectAll": "Tümünü Seç",
  "sorts": {
    "client": "Müşteri",
    "dueDate": "Tarih",
    "orderDate": "Sipariş Tarihi",
    "receptionDate": "Talep Tarihi",
    "reference": "Referans"
  },
  "status": {
    "NOT_UPLOADED": "",
    "PROCESSED": "Yüklendi",
    "REJECTED": "",
    "UPLOADED": "Yüklendi"
  },
  "submitModal": {
    "composition": "Bileşim",
    "confidenceStatement": "İşte, sağladığım bilgilerin doğru ve eksiksiz olduğunu resmi olarak beyan ediyorum",
    "confirmation_one": "{{count}} izlenebilirlik isteği başarıyla gönderildi",
    "confirmation_other": "{{count}} izlenebilirlik isteği başarıyla gönderildi",
    "error": "hata",
    "noRequests": "Gönderilecek tamamlanmış isteğiniz yok bu sayfada",
    "reference": "Referans",
    "submitButton": "Onayla ({{ itemCount }})",
    "title": "Göndermek istediğiniz tüm istekleri seçin",
    "type": "Tip"
  },
  "supplierSettings": {
    "filters": {
      "productionSite": "productionSite",
      "status": "Durum",
      "tags": "Etiketler"
    }
  },
  "tooltips": {
    "contact": "İlgili bilgileri sağlayan kişi",
    "productionSite": "Üretim sitesi, üretim veya işleme işlemlerinin gerçekleştiği kayıtlı bir yerdir. Her site genellikle tek bir üretim akışıyla ilişkilendirilir, ancak birden fazla işlemle birleştirilebilir.",
    "purchaseOrderRef": "Bu {{type}} için sipariş numarası veya fatura numarası",
    "reference": "İlgili ürün, bileşen veya malzeme için referans"
  },
  "transferModal": {
    "success": "Sertifika transferi başarıyla tamamlandı",
    "title": "Sertifika transferi"
  },
  "uniqueActivitiesLabels": {
    "accessoryProvider": "Aksesuar Sağlayıcı",
    "accessoryRawMaterialProvider": "Hammadde Sağlayıcı",
    "apparel": {
      "duvet": {
        "baffle": "Baffle",
        "farm": "Çiftlik (yorgan)",
        "materialProduction": "Hammadde (yorgan)",
        "preProcessor": "Ön İşlemci"
      },
      "fabric": {
        "appret": "Apre (kumaş)",
        "coating": "Kaplam (kumaş)",
        "dyeing": "Boyama/baskı (kumaş)",
        "lamination": "Laminasyon",
        "materialProduction": "Hammadde (kumaş)",
        "spinning": "İplik üretimi (kumaş)",
        "weavingKnitting": "Dokuma/Örme"
      },
      "leather": {
        "appret": "Apre (deri)",
        "dyeing": "Boyama (deri)",
        "farm": "Çiftlik (deri)",
        "materialProduction": "Kıyıhane",
        "tanning": "Deri tabaklama"
      },
      "manufacturing": "Konfeksiyon üretimi",
      "yarn": {
        "dyeing": "Boyama (iplik)",
        "materialProduction": "Hammadde (iplik)",
        "spinning": "İplik üretimi (iplik)"
      }
    },
    "brand": "marka",
    "certifiedEntity": "sertifikalıVarlık",
    "footwear": {
      "assembling": "Montaj",
      "finishing": "Finisaj",
      "stitching": "Dikiş"
    },
    "noActivity": "noActivity",
    "paper": {
      "assembling": "Kağıt montajı",
      "bleaching": "Ağartma",
      "chemicalTreatment": "Kimyasal işlem",
      "laminating": "Laminasyon",
      "manufacturing": "Kağıt üretimi",
      "pressing": "Presleme",
      "printing": "Baskı",
      "resineRemoving": "Reçine giderme",
      "whiteWashing": "Beyaz yıkama"
    },
    "product": {
      "productWashing": "Ürün yıkama",
      "washing": "Yıkama"
    },
    "wood": {
      "assembling": "Ahşap montajı",
      "brushing": "Fırçalama",
      "calibrationAndCollage": "Kalibrasyon ve kolaj",
      "harvesting": "Hasat",
      "manufacturing": "Ahşap üretimi",
      "materialDrying": "Kurutma",
      "materialPeeking": "Ayıklama",
      "materialPeeling": "Soyma",
      "materialSawing": "Kesim",
      "sanding": "Zımpara"
    }
  }
}
